export const USER_CHANGE = "USER_CHANGE";
export const SET_ACCESS_TOKEN = "SET ACCESS TOKEN";
export const SET_USER_NAME = "SET USER NAME";
export const SET_API_BASE = "SET API BASE";
export const SET_REGKEY = "SET_REGKEY";
export const SET_RESET_TOKEN = "SET_RESET_TOKEN";
export const SET_FIRST_NAME = "SET_FIRST_NAME";
export const SET_EMAIL = "SET_EMAIL";
